var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "category__bubble js-category__bubble" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "category__container single__category__container" },
        [
          _c(
            "div",
            { staticClass: "category-breadcrumb" },
            [_vm._t("breadcrumb")],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "d-none", attrs: { id: "single__parent-cat-id" } },
        [_vm._v(_vm._s(_vm.currentVariation.ids.categories.all[0]))]
      ),
      _vm._v(" "),
      _vm._t(
        "default",
        function() {
          return [
            _c(
              "div",
              { staticClass: "single container-max page-content" },
              [
                _c("div", { staticClass: "single__main" }, [
                  _c(
                    "div",
                    { staticClass: "row m-t-3 single__inner-container" },
                    [
                      _c("div", { staticClass: "single-leftside" }, [
                        _c(
                          "div",
                          { staticClass: "single-leftside__scrollable" },
                          [
                            _vm._t("image-carousel"),
                            _vm._v(" "),
                            !_vm.$store.state.viewport.isMobile
                              ? _c(
                                  "div",
                                  { staticClass: "single__fullscreen" },
                                  [
                                    _c("a", { attrs: { href: "#" } }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "12px",
                                            height: "11px"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#svg_zoom",
                                              "xmlns:xlink":
                                                "https://www.w3.org/1999/xlink"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleFullscreen"
                                            )
                                          )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$store.state.viewport.isLg ||
                            _vm.$store.state.viewport.isXl
                              ? _c("div", [_vm._t("crosssellingbasket")], 2)
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasDoc1 ||
                            _vm.hasDoc2 ||
                            _vm.hasVideo1 ||
                            _vm.hasVideo2
                              ? _c(
                                  "div",
                                  { staticClass: "single__video-doc-headline" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Froschkoenig::Template.singleDocVideoHeadline"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasDoc1 ||
                            _vm.hasDoc2 ||
                            _vm.hasVideo1 ||
                            _vm.hasVideo2
                              ? _c(
                                  "div",
                                  { staticClass: "single__video-doc-wrapper" },
                                  [
                                    _vm.hasVideo1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "single-leftside__video",
                                            attrs: { target: "_blank" },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleModal(1)
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                height: "112",
                                                width: "112",
                                                loading: "lazy",
                                                src:
                                                  "https://img.youtube.com/vi/" +
                                                  _vm.currentVariation.item
                                                    .free3 +
                                                  "/1.jpg",
                                                alt: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "25px",
                                                    height: "31px",
                                                    viewBox: "0 0 25 31",
                                                    version: "1.1",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink":
                                                      "http://www.w3.org/1999/xlink"
                                                  }
                                                },
                                                [
                                                  _c("title", [
                                                    _vm._v("Triangle 2")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        id: "Redesign-2022",
                                                        stroke: "none",
                                                        "stroke-width": "1",
                                                        fill: "none",
                                                        "fill-rule": "evenodd"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "xl-article-crossselling-redesign-2022-01-1-copy",
                                                            transform:
                                                              "translate(-307.000000, -949.000000)",
                                                            fill: "#95C300",
                                                            "fill-rule":
                                                              "nonzero"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "g",
                                                            {
                                                              attrs: {
                                                                id: "00-links-",
                                                                transform:
                                                                  "translate(263.000000, 901.000000)"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "g",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "00-video",
                                                                    transform:
                                                                      "translate(0.000000, 23.000000)"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "polygon",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "Triangle-2",
                                                                        points:
                                                                          "68.6933333 40.32 44.8 55.2533333 44.8 25.3866667"
                                                                      }
                                                                    }
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Froschkoenig::Template.singleVideo"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasVideo2
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "single-leftside__video",
                                            attrs: { target: "_blank" },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleModal(2)
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                height: "112",
                                                width: "112",
                                                loading: "lazy",
                                                src:
                                                  "https://img.youtube.com/vi/" +
                                                  _vm.currentVariation.item
                                                    .free14 +
                                                  "/1.jpg",
                                                alt: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "25px",
                                                    height: "31px",
                                                    viewBox: "0 0 25 31",
                                                    version: "1.1",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink":
                                                      "http://www.w3.org/1999/xlink"
                                                  }
                                                },
                                                [
                                                  _c("title", [
                                                    _vm._v("Triangle 2")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        id: "Redesign-2022",
                                                        stroke: "none",
                                                        "stroke-width": "1",
                                                        fill: "none",
                                                        "fill-rule": "evenodd"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "xl-article-crossselling-redesign-2022-01-1-copy",
                                                            transform:
                                                              "translate(-307.000000, -949.000000)",
                                                            fill: "#95C300",
                                                            "fill-rule":
                                                              "nonzero"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "g",
                                                            {
                                                              attrs: {
                                                                id: "00-links-",
                                                                transform:
                                                                  "translate(263.000000, 901.000000)"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "g",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "00-video",
                                                                    transform:
                                                                      "translate(0.000000, 23.000000)"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "polygon",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "Triangle-2",
                                                                        points:
                                                                          "68.6933333 40.32 44.8 55.2533333 44.8 25.3866667"
                                                                      }
                                                                    }
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Froschkoenig::Template.singleVideo"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.videoContent === 1
                                      ? _c(
                                          "portal",
                                          { attrs: { to: "singlevideo" } },
                                          [
                                            _c("iframe", {
                                              attrs: {
                                                width: "100%",
                                                height: "360px",
                                                src:
                                                  "https://www.youtube.com/embed/" +
                                                  _vm.currentVariation.item
                                                    .free3,
                                                frameborder: "0",
                                                allow:
                                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                                allowfullscreen: ""
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.videoContent === 2
                                      ? _c(
                                          "portal",
                                          { attrs: { to: "singlevideo" } },
                                          [
                                            _c("iframe", {
                                              attrs: {
                                                width: "100%",
                                                height: "360px",
                                                src:
                                                  "https://www.youtube.com/embed/" +
                                                  _vm.currentVariation.item
                                                    .free14,
                                                frameborder: "0",
                                                allow:
                                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                                allowfullscreen: ""
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasDoc1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "single-leftside__doc",
                                            attrs: {
                                              href:
                                                _vm.currentVariation.item.free1,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                height: "112",
                                                width: "112",
                                                loading: "lazy",
                                                src:
                                                  _vm.pluginPath +
                                                  "/images/Prospektbild.jpeg",
                                                alt: "Doc"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "26px",
                                                    height: "27px",
                                                    viewBox: "0 0 26 27",
                                                    version: "1.1",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink":
                                                      "http://www.w3.org/1999/xlink"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        id: "Redesign-2022",
                                                        stroke: "none",
                                                        "stroke-width": "1",
                                                        fill: "none",
                                                        "fill-rule": "evenodd"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "xl-article-crossselling-redesign-2022-01-1-copy",
                                                            transform:
                                                              "translate(-550.000000, -954.000000)",
                                                            fill: "#95C300",
                                                            "fill-rule":
                                                              "nonzero"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "g",
                                                            {
                                                              attrs: {
                                                                id: "00-links-",
                                                                transform:
                                                                  "translate(263.000000, 901.000000)"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "g",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "Group-7",
                                                                    transform:
                                                                      "translate(244.000000, 23.000000)"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "flyer-(1)",
                                                                        transform:
                                                                          "translate(43.000000, 30.500000)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M23.4132031,0 L10.745668,0 C9.31927344,0 8.15882031,1.16045312 8.15882031,2.58684766 L8.15882031,3.65127344 L2.53454297,3.65127344 C1.13699219,3.65127344 0,4.78826562 0,6.18581641 L0,23.465457 C0,24.8630078 1.13699219,26 2.53454297,26 L15.3065859,26 C16.7041367,26 17.8411289,24.8630078 17.8411289,23.465457 L17.8411289,22.3487773 L23.4132031,22.3487773 C24.8395977,22.3487773 26,21.1883242 26,19.7619297 L26,2.58684766 C26,1.16045312 24.8395469,0 23.4132031,0 Z M16.3176914,23.465457 C16.3176914,24.0229844 15.8640625,24.4765625 15.3065859,24.4765625 L2.53454297,24.4765625 C1.97701563,24.4765625 1.5234375,24.0229844 1.5234375,23.465457 L1.5234375,6.18581641 C1.5234375,5.62828906 1.97701563,5.17471094 2.53454297,5.17471094 L15.3065859,5.17471094 C15.8641133,5.17471094 16.3176914,5.62828906 16.3176914,6.18581641 L16.3176914,23.465457 Z M24.4765625,19.7619297 C24.4765625,20.3483008 23.9995234,20.8253398 23.4132031,20.8253398 L17.8411289,20.8253398 L17.8411289,6.18581641 C17.8411289,4.78826563 16.7041367,3.65127344 15.3065859,3.65127344 L9.68230859,3.65127344 L9.68230859,2.58684766 C9.68230859,2.00047656 10.1593477,1.5234375 10.7457187,1.5234375 L23.4132031,1.5234375 C23.9995234,1.5234375 24.4765625,2.00047656 24.4765625,2.58684766 L24.4765625,19.7619297 Z",
                                                                            id:
                                                                              "Shape"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M14.7,13.7503437 L4.2,13.7503437 C3.64771525,13.7503437 3.2,13.3026285 3.2,12.7503437 L3.2,7.75034375 C3.2,7.198059 3.64771525,6.75034375 4.2,6.75034375 L13.7,6.75034375 C14.2522847,6.75034375 14.7,7.198059 14.7,7.75034375 L14.7,13.7503437 L14.7,13.7503437 Z",
                                                                            id:
                                                                              "Shape"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M14.0083125,16.6398984 L3.83281641,16.6398984 C3.41214453,16.6398984 3.07109766,16.9809453 3.07109766,17.4016172 C3.07109766,17.8222891 3.41214453,18.1633359 3.83281641,18.1633359 L14.0083633,18.1633359 C14.4290352,18.1633359 14.770082,17.8222891 14.770082,17.4016172 C14.770082,16.9809453 14.4290352,16.6398984 14.0083125,16.6398984 Z",
                                                                            id:
                                                                              "Path"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M14.0083125,19.1570234 L3.83281641,19.1570234 C3.41214453,19.1570234 3.07109766,19.4980703 3.07109766,19.9187422 C3.07109766,20.3394141 3.41214453,20.6804609 3.83281641,20.6804609 L14.0083633,20.6804609 C14.4290352,20.6804609 14.770082,20.3394141 14.770082,19.9187422 C14.770082,19.4980703 14.4290352,19.1570234 14.0083125,19.1570234 Z",
                                                                            id:
                                                                              "Path"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M13.9709883,21.6740977 L11.1720273,21.6740977 C10.7513555,21.6740977 10.4103086,22.0151445 10.4103086,22.4358164 C10.4103086,22.8564883 10.7513555,23.1975352 11.1720273,23.1975352 L13.9709883,23.1975352 C14.3916602,23.1975352 14.732707,22.8564883 14.732707,22.4358164 C14.732707,22.0151445 14.3916602,21.6740977 13.9709883,21.6740977 Z",
                                                                            id:
                                                                              "Path"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Froschkoenig::Template.singleDoc"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasDoc2
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "single-leftside__doc",
                                            attrs: {
                                              href:
                                                _vm.currentVariation.item.free2,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                height: "112",
                                                width: "112",
                                                loading: "lazy",
                                                src:
                                                  _vm.pluginPath +
                                                  "/images/Prospektbild.jpeg",
                                                alt: "Doc"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "26px",
                                                    height: "27px",
                                                    viewBox: "0 0 26 27",
                                                    version: "1.1",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink":
                                                      "http://www.w3.org/1999/xlink"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        id: "Redesign-2022",
                                                        stroke: "none",
                                                        "stroke-width": "1",
                                                        fill: "none",
                                                        "fill-rule": "evenodd"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "xl-article-crossselling-redesign-2022-01-1-copy",
                                                            transform:
                                                              "translate(-550.000000, -954.000000)",
                                                            fill: "#95C300",
                                                            "fill-rule":
                                                              "nonzero"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "g",
                                                            {
                                                              attrs: {
                                                                id: "00-links-",
                                                                transform:
                                                                  "translate(263.000000, 901.000000)"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "g",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "Group-7",
                                                                    transform:
                                                                      "translate(244.000000, 23.000000)"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "flyer-(1)",
                                                                        transform:
                                                                          "translate(43.000000, 30.500000)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M23.4132031,0 L10.745668,0 C9.31927344,0 8.15882031,1.16045312 8.15882031,2.58684766 L8.15882031,3.65127344 L2.53454297,3.65127344 C1.13699219,3.65127344 0,4.78826562 0,6.18581641 L0,23.465457 C0,24.8630078 1.13699219,26 2.53454297,26 L15.3065859,26 C16.7041367,26 17.8411289,24.8630078 17.8411289,23.465457 L17.8411289,22.3487773 L23.4132031,22.3487773 C24.8395977,22.3487773 26,21.1883242 26,19.7619297 L26,2.58684766 C26,1.16045312 24.8395469,0 23.4132031,0 Z M16.3176914,23.465457 C16.3176914,24.0229844 15.8640625,24.4765625 15.3065859,24.4765625 L2.53454297,24.4765625 C1.97701563,24.4765625 1.5234375,24.0229844 1.5234375,23.465457 L1.5234375,6.18581641 C1.5234375,5.62828906 1.97701563,5.17471094 2.53454297,5.17471094 L15.3065859,5.17471094 C15.8641133,5.17471094 16.3176914,5.62828906 16.3176914,6.18581641 L16.3176914,23.465457 Z M24.4765625,19.7619297 C24.4765625,20.3483008 23.9995234,20.8253398 23.4132031,20.8253398 L17.8411289,20.8253398 L17.8411289,6.18581641 C17.8411289,4.78826563 16.7041367,3.65127344 15.3065859,3.65127344 L9.68230859,3.65127344 L9.68230859,2.58684766 C9.68230859,2.00047656 10.1593477,1.5234375 10.7457187,1.5234375 L23.4132031,1.5234375 C23.9995234,1.5234375 24.4765625,2.00047656 24.4765625,2.58684766 L24.4765625,19.7619297 Z",
                                                                            id:
                                                                              "Shape"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M14.7,13.7503437 L4.2,13.7503437 C3.64771525,13.7503437 3.2,13.3026285 3.2,12.7503437 L3.2,7.75034375 C3.2,7.198059 3.64771525,6.75034375 4.2,6.75034375 L13.7,6.75034375 C14.2522847,6.75034375 14.7,7.198059 14.7,7.75034375 L14.7,13.7503437 L14.7,13.7503437 Z",
                                                                            id:
                                                                              "Shape"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M14.0083125,16.6398984 L3.83281641,16.6398984 C3.41214453,16.6398984 3.07109766,16.9809453 3.07109766,17.4016172 C3.07109766,17.8222891 3.41214453,18.1633359 3.83281641,18.1633359 L14.0083633,18.1633359 C14.4290352,18.1633359 14.770082,17.8222891 14.770082,17.4016172 C14.770082,16.9809453 14.4290352,16.6398984 14.0083125,16.6398984 Z",
                                                                            id:
                                                                              "Path"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M14.0083125,19.1570234 L3.83281641,19.1570234 C3.41214453,19.1570234 3.07109766,19.4980703 3.07109766,19.9187422 C3.07109766,20.3394141 3.41214453,20.6804609 3.83281641,20.6804609 L14.0083633,20.6804609 C14.4290352,20.6804609 14.770082,20.3394141 14.770082,19.9187422 C14.770082,19.4980703 14.4290352,19.1570234 14.0083125,19.1570234 Z",
                                                                            id:
                                                                              "Path"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M13.9709883,21.6740977 L11.1720273,21.6740977 C10.7513555,21.6740977 10.4103086,22.0151445 10.4103086,22.4358164 C10.4103086,22.8564883 10.7513555,23.1975352 11.1720273,23.1975352 L13.9709883,23.1975352 C14.3916602,23.1975352 14.732707,22.8564883 14.732707,22.4358164 C14.732707,22.0151445 14.3916602,21.6740977 13.9709883,21.6740977 Z",
                                                                            id:
                                                                              "Path"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Froschkoenig::Template.singleDoc"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "single-rightside m-t-1" }, [
                        _c(
                          "div",
                          { staticClass: "single-rightside--inner" },
                          [
                            _c(
                              "h1",
                              { staticClass: "h2 title single-rightside--1" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("itemName")(_vm.currentVariation)
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row single-rightside--2" },
                              [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "span",
                                    { staticClass: "price" },
                                    [
                                      _c("item-price", {
                                        attrs: {
                                          "show-cross-price":
                                            _vm.isRecommendedPriceActive
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "vat small" }, [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleVat1"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "vat--green" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.singleVat2"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-bottom" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "item-bottom__item item-bottom__item--share d-lg-none"
                                    },
                                    [
                                      _c("span", [
                                        _c("i", {
                                          staticClass: "fa fa-share-alt"
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleSocial"
                                              )
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._m(0)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "item-bottom__item item-bottom__item--wishlist d-lg-none"
                                    },
                                    [
                                      _c("add-to-wish-list", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-lg-6 mt-2 js--trustpilot-reviews",
                                    class: {
                                      "trustpilot-reviews": _vm.trustpilotFound
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.toggleReviewsTab()
                                        _vm.scrollToDescription(true)
                                      }
                                    }
                                  },
                                  [_vm._t("trustpilot-widget-small")],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 single__sharing-n-stuff"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "item-bottom__item item-bottom__item--share"
                                      },
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass: "fa fa-share-alt"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.singleSocial"
                                                )
                                              )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._m(1)
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "item-bottom__item item-bottom__item--wishlist"
                                      },
                                      [
                                        _c("add-to-wish-list", {
                                          attrs: {
                                            "variation-id":
                                              _vm.currentVariation.variation.id
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.$store.state.viewport.isMobile
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row single__variation-selection single-rightside--3"
                                  },
                                  [
                                    _vm.attributes.length ||
                                    Object.keys(_vm.units).length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-md-6 col-lg-12 single__variation-selection--zubehoer"
                                          },
                                          [_c("variation-select")],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._t("crosssellingsimilar"),
                                    _vm._v(" "),
                                    _c("hr")
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("hr", { staticClass: "single-rightside--4" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row single-rightside--5" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-md-6 d-block d-md-none"
                                  },
                                  [
                                    _vm.currentVariation.stock.net > 0
                                      ? _c(
                                          "p",
                                          { staticClass: "single__stock" },
                                          [
                                            _vm.currentVariation.stock.net > 10
                                              ? _c("span", [
                                                  _c("span", {
                                                    staticClass:
                                                      "stock-indicator stock-indicator-green"
                                                  }),
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Froschkoenig::Template.singleStockMoreThan10"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ])
                                              : _c("span", [
                                                  _c("span", {
                                                    staticClass:
                                                      "stock-indicator stock-indicator-red"
                                                  }),
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Froschkoenig::Template.singleStockOnly1"
                                                        )
                                                      ) +
                                                      "\n                                            " +
                                                      _vm._s(
                                                        _vm.currentVariation
                                                          .stock.net
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Froschkoenig::Template.singleStockOnly2"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.currentVariation.filter.isSalable &&
                            _vm.variationGroupedProperties.length
                              ? _c(
                                  "div",
                                  { staticClass: "row single-rightside--6" },
                                  [_c("order-property-list")],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("graduated-prices"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row single__article-info-container single-rightside--8"
                              },
                              [
                                _vm.currentVariation.stock.net > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 d-none d-md-block mb-3"
                                      },
                                      [
                                        _vm.currentVariation.stock.net > 10
                                          ? _c("div", [
                                              _c("div", {
                                                staticClass:
                                                  "stock-indicator stock-indicator-green"
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Froschkoenig::Template.singleStockMoreThan10"
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ])
                                          : _c("div", [
                                              _c("div", {
                                                staticClass:
                                                  "stock-indicator stock-indicator-red"
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Froschkoenig::Template.singleStockOnly1"
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.currentVariation.stock
                                                      .net
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Froschkoenig::Template.singleStockOnly2"
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-md-6 col-lg-12 col-xl-9"
                                  },
                                  [
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table single__details-table"
                                      },
                                      [
                                        _c(
                                          "tbody",
                                          [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "single__td-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.singleItemNumber"
                                                      )
                                                    ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation.item.id
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "single__td-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.singleItemDimensions"
                                                      )
                                                    ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [_vm._t("abmessungen")],
                                                2
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "single__td-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Froschkoenig::Template.singleItemLieferzeit"
                                                      )
                                                    ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  class:
                                                    "single__availability-label-" +
                                                    _vm.currentVariation
                                                      .variation.availability.id
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.currentVariation
                                                          .variation
                                                          .availability.names
                                                          .name
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.varProps.length > 0
                                              ? [
                                                  _vm._l(_vm.varProps, function(
                                                    prop
                                                  ) {
                                                    return [
                                                      prop.values.selectionId ==
                                                      302
                                                        ? [
                                                            _c("tr", [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "single__td-label"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$translate(
                                                                        "Froschkoenig::Template.singleShippingInfo"
                                                                      )
                                                                    ) +
                                                                      "\n                                                            "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "shippinginfo-link shippinginfo-link--no-border",
                                                                    attrs: {
                                                                      "data-toggle":
                                                                        "modal",
                                                                      href:
                                                                        "#shippinginfo"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                                    " +
                                                                        _vm._s(
                                                                          _vm.$translate(
                                                                            "Froschkoenig::Template.singleShippingInfoShow"
                                                                          )
                                                                        ) +
                                                                        "\n                                                                    "
                                                                    ),
                                                                    _c(
                                                                      "svg",
                                                                      {
                                                                        staticClass:
                                                                          "svg-icon__icon",
                                                                        attrs: {
                                                                          role:
                                                                            "img",
                                                                          focusable:
                                                                            "false",
                                                                          viewBox:
                                                                            "0 0 22 22",
                                                                          xmlns:
                                                                            "http://www.w3.org/2000/svg"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "path",
                                                                          {
                                                                            attrs: {
                                                                              d:
                                                                                "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "path",
                                                                          {
                                                                            attrs: {
                                                                              d:
                                                                                "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            ])
                                                          ]
                                                        : _vm._e()
                                                    ]
                                                  })
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentVariation.variation
                                              .weightG > 0
                                              ? _c(
                                                  "tr",
                                                  {
                                                    staticClass:
                                                      "toggle-hidden",
                                                    class: {
                                                      hidden: !_vm.showMore
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "single__td-label"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$translate(
                                                              "Froschkoenig::Template.singleShippingWeight"
                                                            )
                                                          ) +
                                                            "\n                                                "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentVariation
                                                            .variation.weightG /
                                                            1000
                                                        ) + " kg"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              {
                                                staticClass: "toggle-hidden",
                                                class: { hidden: !_vm.showMore }
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "single__td-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Froschkoenig::Template.singleShippingCondition"
                                                        )
                                                      ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [_vm._t("free6")], 2)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              {
                                                staticClass: "toggle-hidden",
                                                class: { hidden: !_vm.showMore }
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "single__td-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Froschkoenig::Template.singleShippingInfoDetails"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [_vm._t("free5")], 2)
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "single-rightside--9" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "single__more-details",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.showMore = !_vm.showMore
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleMoreInfo"
                                      )
                                    ) + " "
                                  ),
                                  _c("i", {
                                    staticClass: "fa  single__more-info-icon",
                                    class: {
                                      "fa-chevron-down": !_vm.showMore,
                                      "fa-chevron-up": _vm.showMore
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "single-rightside--10 d-flex justify-content-between flex-wrap"
                              },
                              [
                                !_vm.hasPaketOrSpeditionProp
                                  ? [
                                      _vm.has304Prop
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "shippinginfo-link",
                                                attrs: {
                                                  "data-toggle": "modal",
                                                  href: "#shippinginfo-304"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.injectPricesIntoModal()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        "xmlns:xlink":
                                                          "http://www.w3.org/1999/xlink",
                                                        "xlink:href":
                                                          "#spedition-no-text"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Froschkoenig::Template.shippinginfoMontage"
                                                      )
                                                    ) +
                                                    "\n                                            "
                                                ),
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "svg-icon__icon",
                                                    attrs: {
                                                      role: "img",
                                                      focusable: "false",
                                                      viewBox: "0 0 22 22",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "shippinginfo-link",
                                                attrs: {
                                                  "data-toggle": "modal",
                                                  href: "#shippinginfo-302"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.injectPricesIntoModal()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        "xmlns:xlink":
                                                          "http://www.w3.org/1999/xlink",
                                                        "xlink:href":
                                                          "#spedition-no-text"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Froschkoenig::Template.shippinginfoSpedNoMontage"
                                                      )
                                                    ) +
                                                    "\n                                            "
                                                ),
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "svg-icon__icon",
                                                    attrs: {
                                                      role: "img",
                                                      focusable: "false",
                                                      viewBox: "0 0 22 22",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                    ]
                                  : [
                                      _vm._l(_vm.varProps, function(prop) {
                                        return [
                                          prop.values.selectionId == 302 ||
                                          prop.values.selectionId == 303
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "shippinginfo-link",
                                                    attrs: {
                                                      "data-toggle": "modal",
                                                      href: _vm.hasShippingPrices
                                                        ? "#shippinginfo-302-prices"
                                                        : "#shippinginfo-302"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.injectPricesIntoModal()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xmlns:xlink":
                                                              "http://www.w3.org/1999/xlink",
                                                            "xlink:href":
                                                              "#spedition-no-text"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.hasShippingPrices
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$translate(
                                                                "Froschkoenig::Template.shippinginfoSpedMontage"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$translate(
                                                                "Froschkoenig::Template.shippinginfoSpedNoMontage"
                                                              )
                                                            )
                                                          )
                                                        ],
                                                    _vm._v(" "),
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "svg-icon__icon",
                                                        attrs: {
                                                          role: "img",
                                                          focusable: "false",
                                                          viewBox: "0 0 22 22",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            : prop.values.selectionId == 301
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "shippinginfo-link",
                                                    attrs: {
                                                      "data-toggle": "modal",
                                                      href: _vm.hasShippingPrices
                                                        ? "#shippinginfo-301-prices"
                                                        : "#shippinginfo-301"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.injectPricesIntoModal()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xmlns:xlink":
                                                              "http://www.w3.org/1999/xlink",
                                                            "xlink:href":
                                                              "#spedition-no-text"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.hasShippingPrices
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$translate(
                                                                "Froschkoenig::Template.shippinginfoPaketMontage"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$translate(
                                                                "Froschkoenig::Template.shippinginfoPaketNoMontage"
                                                              )
                                                            )
                                                          )
                                                        ],
                                                    _vm._v(" "),
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "svg-icon__icon",
                                                        attrs: {
                                                          role: "img",
                                                          focusable: "false",
                                                          viewBox: "0 0 22 22",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            : prop.values.selectionId == 304
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "shippinginfo-link",
                                                    attrs: {
                                                      "data-toggle": "modal",
                                                      href: "#shippinginfo-304"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.injectPricesIntoModal()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xmlns:xlink":
                                                              "http://www.w3.org/1999/xlink",
                                                            "xlink:href":
                                                              "#spedition-no-text"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Froschkoenig::Template.shippinginfoMontage"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "svg-icon__icon",
                                                        attrs: {
                                                          role: "img",
                                                          focusable: "false",
                                                          viewBox: "0 0 22 22",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "single__goto-description shippinginfo-link d-flex flex-wrap flex-lg-nowrap",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.scrollToDescription()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Froschkoenig::Template.singleGotoDescription"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "single-rightside--11" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-none single-rightside--12" },
                              [_vm._t("variationimage")],
                              2
                            ),
                            _vm._v(" "),
                            !_vm.$store.state.viewport.isMobile
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row single__variation-selection single-rightside--13"
                                  },
                                  [
                                    _vm.attributes.length ||
                                    Object.keys(_vm.units).length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-md-6 col-lg-12 single__variation-selection--zubehoer"
                                          },
                                          [_c("variation-select")],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._t("crosssellingsimilar"),
                                    _vm._v(" "),
                                    _c("hr")
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$store.state.viewport.isMobile
                              ? _c("hr", {
                                  staticClass: "single-rightside--14"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row m-y-1 single__add-to-basket-row single-rightside--16"
                              },
                              [
                                _c("add-to-basket", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties": _vm.currentVariation.properties.filter(
                                      function(prop) {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._t("before-add-to-basket"),
                            _vm._v(" "),
                            _vm._t("after-add-to-basket"),
                            _vm._v(" "),
                            _vm._t("after-price"),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                ref: "scroll",
                                staticClass:
                                  "single__get-offer single-rightside--17",
                                attrs: { href: "#" }
                              },
                              [
                                _c(
                                  "svg",
                                  { attrs: { width: "30px", height: "25px" } },
                                  [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#svg_offer",
                                        "xmlns:xlink":
                                          "https://www.w3.org/1999/xlink"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleGetOffer"
                                      )
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "payment-icons single-rightside--18"
                              },
                              [
                                _c(
                                  "li",
                                  { staticClass: "payment-icons__item" },
                                  [
                                    _c(
                                      "svg",
                                      { staticClass: "payment-icons__svg" },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#paypal-single",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  { staticClass: "payment-icons__item" },
                                  [
                                    _c(
                                      "svg",
                                      { staticClass: "payment-icons__svg" },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#vorkasse-single",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  { staticClass: "payment-icons__item" },
                                  [
                                    _c(
                                      "svg",
                                      { staticClass: "payment-icons__svg" },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#lastschrift-single",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  { staticClass: "payment-icons__item" },
                                  [
                                    _c(
                                      "svg",
                                      { staticClass: "payment-icons__svg" },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#sofort-single",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "payment-icons__item payment-icons__item--spacing"
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "81",
                                          height: "20",
                                          viewBox: "0 0 81 20"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              transform:
                                                "translate(0, 0) scale(1)"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M78.3352549,14.3292706 C77.0678017,14.3292706 76.0403439,15.3567284 76.0403439,16.6243597 C76.0403439,17.8916348 77.0678017,18.9192707 78.3352549,18.9192707 C79.6027081,18.9192707 80.630344,17.8916348 80.630344,16.6243597 C80.630344,15.3567284 79.6027081,14.3292706 78.3352549,14.3292706",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M70.7958568,7.22817345 L70.7958568,6.4467803 L74.4529833,6.4467803 L74.4529833,18.6618356 L70.7958568,18.6618356 L70.7958568,17.8811547 C69.7626656,18.5857975 68.5156063,19 67.1704277,19 C63.6107082,19 60.7250027,16.1142945 60.7250027,12.554575 C60.7250027,8.99485561 63.6107082,6.10915009 67.1704277,6.10915009 C68.5156063,6.10915009 69.7626656,6.52335256 70.7958568,7.22817345 Z M67.4697718,15.6974209 C69.3000267,15.6974209 70.7835696,14.2902722 70.7835696,12.554575 C70.7835696,10.8188779 69.3000267,9.41208536 67.4697718,9.41208536 C65.6395168,9.41208536 64.1559739,10.8188779 64.1559739,12.554575 C64.1559739,14.2902722 65.6395168,15.6974209 67.4697718,15.6974209 Z",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M54.2263333,6.11823191 C52.765406,6.11823191 51.3828316,6.57178896 50.4584442,7.82312205 L50.4584442,6.4474926 L46.8169884,6.4474926 L46.8169884,18.6618356 L50.503141,18.6618356 L50.503141,12.2427657 C50.503141,10.3852653 51.7487757,9.47565814 53.2485235,9.47565814 C54.8558285,9.47565814 55.7798597,10.4358386 55.7798597,12.2174791 L55.7798597,18.6618356 L59.4327124,18.6618356 L59.4327124,10.8940256 C59.4327124,8.05141421 57.1725844,6.11823191 54.2263333,6.11823191",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M41.5278044,8.03788051 L41.5278044,6.44695838 L37.7834212,6.44695838 L37.7834212,18.6618356 L41.536174,18.6618356 L41.536174,12.9588053 C41.536174,11.0347048 43.6216104,10.0004452 45.0686479,10.0004452 C45.0834281,10.0004452 45.097318,10.0018698 45.1120982,10.0020479 L45.1120982,6.44767068 C43.6269526,6.44767068 42.2609392,7.08357654 41.5278044,8.03788051",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M32.2128788,7.22817345 L32.2128788,6.4467803 L35.8701833,6.4467803 L35.8701833,18.6618356 L32.2128788,18.6618356 L32.2128788,17.8811547 C31.1796876,18.5857975 29.9326283,19 28.5876277,19 C25.0279083,19 22.1422028,16.1142945 22.1422028,12.554575 C22.1422028,8.99485561 25.0279083,6.10915009 28.5876277,6.10915009 C29.9326283,6.10915009 31.1796876,6.52335256 32.2128788,7.22817345 Z M28.8867938,15.6974209 C30.7170487,15.6974209 32.2007697,14.2902722 32.2007697,12.554575 C32.2007697,10.8188779 30.7170487,9.41208536 28.8867938,9.41208536 C27.0567169,9.41208536 25.5729959,10.8188779 25.5729959,12.554575 C25.5729959,14.2902722 27.0567169,15.6974209 28.8867938,15.6974209 Z",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M16.8150889 18.6618356 20.6429893 18.6618356 20.6429893 1.00338343 16.8150889 1.00338343z",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M14.1770857,1 L10.2104649,1 C10.2104649,4.25111544 8.71570325,7.23511837 6.10957549,9.1873547 L4.53806353,10.3642524 L10.6271604,18.6673559 L15.6335612,18.6673559 L10.0307872,11.0272257 C12.6865979,8.38263373 14.1770857,4.82469505 14.1770857,1",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              staticClass: "fill",
                                              attrs: {
                                                d:
                                                  "M0 18.6666436 4.05334336 18.6666436 4.05334336 1 0 1z",
                                                fill: "rgba(23, 18, 15, 1)"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "payment-icons__item payment-icons__item--spacing"
                                  },
                                  [
                                    _c("div", { staticClass: "payment-bg" }, [
                                      _c("img", {
                                        staticClass:
                                          "lazy-img payment-icons__img",
                                        attrs: {
                                          "data-src":
                                            _vm.pluginPath +
                                            "/images/easycredit_neu.png",
                                          "data-srcset":
                                            _vm.pluginPath +
                                            "/images/easycredit_neu.png",
                                          alt: "easyCredit"
                                        }
                                      })
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  { staticClass: "payment-icons__item" },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "lazy-img img-br payment-icons__img",
                                      attrs: {
                                        "data-src":
                                          _vm.pluginPath +
                                          "/images/barzahlung.jpg",
                                        "data-srcset":
                                          _vm.pluginPath +
                                          "/images/barzahlung.jpg",
                                        alt: "Barzahlung"
                                      }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._t("before-price"),
                            _vm._v(" "),
                            _vm._t("additional-content-after-add-to-basket"),
                            _vm._v(" "),
                            _vm._t("additional-content-after-VAT")
                          ],
                          2
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.crosssellinglist1.length > 0 ||
                _vm.crosssellinglist2.length > 0 ||
                _vm.currentVariation.variation.bundleType === "bundle"
                  ? _c("div", { staticClass: "single__crossselling-tabs" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-tabs",
                          attrs: { id: "myTab", role: "tablist" }
                        },
                        [
                          _vm.crosssellinglist1.length > 0
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      id: "crossseller-1-tab",
                                      "data-toggle": "tab",
                                      href: "#crossseller-1",
                                      role: "tab",
                                      "aria-controls": "home",
                                      "aria-selected": "true"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Froschkoenig::Template.singleCrossseller1Headline"
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.crosssellinglist2.length > 0
                            ? _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  class: {
                                    active: _vm.crosssellinglist1.length === 0
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        id: "crossseller-2-tab",
                                        "data-toggle": "tab",
                                        href: "#crossseller-2",
                                        role: "tab",
                                        "aria-controls": "profile",
                                        "aria-selected": "false"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleCrossseller2Headline"
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  class: {
                                    active:
                                      _vm.crosssellinglist1.length === 0 &&
                                      _vm.crosssellinglist2.length === 0
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        id: "set-items-tab",
                                        "data-toggle": "tab",
                                        href: "#set-items",
                                        role: "tab",
                                        "aria-controls": "profile",
                                        "aria-selected": "false"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleSetContent"
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tab-content",
                          attrs: { id: "myTabContent" }
                        },
                        [
                          _vm.crosssellinglist1.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane fade show active",
                                  attrs: {
                                    id: "crossseller-1",
                                    role: "tabpanel",
                                    "aria-labelledby": "crossseller-1-tab"
                                  }
                                },
                                [_vm._t("crosssellinglist1")],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.crosssellinglist2.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane fade",
                                  class: {
                                    "show active":
                                      _vm.crosssellinglist1.length === 0
                                  },
                                  attrs: {
                                    id: "crossseller-2",
                                    role: "tabpanel",
                                    "aria-labelledby": "crossseller-2-tab"
                                  }
                                },
                                [_vm._t("crosssellinglist2")],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane fade",
                                  class: {
                                    "show active":
                                      _vm.crosssellinglist1.length === 0
                                  },
                                  attrs: {
                                    id: "set-items",
                                    role: "tabpanel",
                                    "aria-labelledby": "set-items-tab"
                                  }
                                },
                                [
                                  _vm.currentVariation.variation.bundleType ===
                                  "bundle"
                                    ? _c("item-bundle", {
                                        attrs: {
                                          "bundle-type":
                                            _vm.currentVariation.variation
                                              .bundleType,
                                          "bundle-components":
                                            _vm.currentVariation
                                              .bundleComponents,
                                          "in-tab": true
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("usp"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "single__shortdescription" },
                  [
                    _vm.currentVariation.texts.shortDescription !== ""
                      ? _c(
                          "div",
                          { staticClass: "single-description__wrapper" },
                          [
                            _c(
                              "p",
                              { staticClass: "single-description__headline" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Froschkoenig::Template.singleShortDescription"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("client-only", [
                              _c("p", {
                                staticClass: "single-description",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.shortDescription
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.currentVariation.texts.shortDescription !== ""
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "js--single-description__more text-more",
                                    attrs: { href: "#" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Froschkoenig::Template.singleShortDescriptionShowMore"
                                        )
                                      ) + " "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-chevron-down"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("shortdesc")
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "m-y-3 single__description" }, [
                  _c("div", { staticClass: "my-5" }, [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "nav nav-tabs nav nav-tabs d-none d-lg-flex",
                        attrs: { role: "tablist" }
                      },
                      [
                        _vm.isDescriptionTabActive
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link active",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#details-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemDescription"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isTechnicalDataTabActive
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive
                                  },
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleTabsProperties"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            on: {
                              "~mouseover": function($event) {
                                return _vm.$store.dispatch(
                                  "loadComponent",
                                  "item-service-versand"
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                attrs: {
                                  href: "#service-versand",
                                  "data-toggle": "tab",
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Froschkoenig::Template.singleTabsService"
                                    )
                                  )
                                ),
                                _c("i", { staticClass: "fa fa-chevron-down" })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            on: {
                              "~mouseover": function($event) {
                                return _vm.$store.dispatch(
                                  "loadComponent",
                                  "item-zahlungsarten"
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                attrs: {
                                  href: "#zahlungsarten",
                                  "data-toggle": "tab",
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Froschkoenig::Template.singleTabsPayments"
                                    )
                                  )
                                ),
                                _c("i", { staticClass: "fa fa-chevron-down" })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link js--reviews-tab",
                              attrs: {
                                href: "#bewertung",
                                "data-toggle": "tab",
                                role: "tab"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Froschkoenig::Template.singleTabsReviews"
                                  )
                                )
                              ),
                              _c("i", { staticClass: "fa fa-chevron-down" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                href: "#contact",
                                "data-toggle": "tab",
                                role: "tab"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Froschkoenig::Template.singleTabsContact"
                                  )
                                )
                              ),
                              _c("i", { staticClass: "fa fa-chevron-down" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs")
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tab-content overflow-hidden" },
                      [
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs d-block d-lg-none ",
                            attrs: { role: "tablist" }
                          },
                          [
                            _vm.isDescriptionTabActive
                              ? _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "nav-link active nav-link--inner",
                                      attrs: {
                                        "data-toggle": "tab",
                                        href:
                                          "#details-" +
                                          _vm.currentVariation.variation.id,
                                        role: "tab"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemDescription"
                                          )
                                        )
                                      ),
                                      _c("i", {
                                        staticClass: "fa fa-chevron-down"
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isDescriptionTabActive
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane active tab-description",
                                attrs: {
                                  id:
                                    "details-" +
                                    _vm.currentVariation.variation.id,
                                  role: "tabpanel"
                                }
                              },
                              [
                                _vm._t("ratgeber"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "my-4" },
                                  [
                                    _c(
                                      "h3",
                                      { staticClass: "description__title h1" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.descriptionFor"
                                            )
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("itemName")(
                                                _vm.currentVariation
                                              )
                                            )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("client-only", [
                                      _c("div", {
                                        ref: "description",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.texts
                                              .description
                                          )
                                        }
                                      })
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "single__links-with-img" },
                                  [
                                    _vm.getVarPropForImageLink(
                                      "Material",
                                      "image"
                                    ) !== ""
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "single__links-with-img-wrapper"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.getVarPropForImageLink(
                                                    "Material",
                                                    "link"
                                                  )
                                                }
                                              },
                                              [
                                                _c("lazy-img", {
                                                  attrs: {
                                                    "picture-class":
                                                      "single__links-with-img-image",
                                                    "image-url": _vm.getVarPropForImageLink(
                                                      "Material",
                                                      "image"
                                                    ),
                                                    alt: "Material",
                                                    title: "Material"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "single__links-with-img-text",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.getVarPropForImageLink(
                                                        "Material",
                                                        "text"
                                                      )
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getVarPropForImageLink(
                                      "Oberfläche",
                                      "image"
                                    ) !== ""
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "single__links-with-img-wrapper"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.getVarPropForImageLink(
                                                    "Oberfläche",
                                                    "link"
                                                  )
                                                }
                                              },
                                              [
                                                _c("lazy-img", {
                                                  attrs: {
                                                    "picture-class":
                                                      "single__links-with-img-image",
                                                    "image-url": _vm.getVarPropForImageLink(
                                                      "Oberfläche",
                                                      "image"
                                                    ),
                                                    alt: "Oberfläche",
                                                    title: "Oberfläche"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "single__links-with-img-text",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.getVarPropForImageLink(
                                                        "Oberfläche",
                                                        "text"
                                                      )
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getVarPropForImageLink(
                                      "Hersteller",
                                      "image"
                                    ) !== ""
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "single__links-with-img-wrapper"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.getVarPropForImageLink(
                                                    "Hersteller",
                                                    "link"
                                                  )
                                                }
                                              },
                                              [
                                                _c("lazy-img", {
                                                  attrs: {
                                                    "picture-class":
                                                      "single__links-with-img-image single__links-with-img-image--brand",
                                                    "image-url": _vm.getVarPropForImageLink(
                                                      "Hersteller",
                                                      "image"
                                                    ),
                                                    alt: "Hersteller",
                                                    title: "Hersteller"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.currentVariation.texts.technicalData != ""
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "single__open-product-details"
                                      },
                                      [
                                        _c(
                                          "button",
                                          { staticClass: "btn btn-primary" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Froschkoenig::Template.singleTabsMoreInfo"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("client-only", [
                                  _c("div", {
                                    staticClass: "item-technical clearfix",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.technicalData
                                      )
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-contact" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "item-contact__item item-contact__item--anfrage"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleTeamTeaser"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-default btn-block item-contact__trigger-form",
                                          attrs: { href: "#" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleTeamContact"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "item-contact__item item-contact__item--links"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "item-contact__item-link",
                                          attrs: {
                                            href:
                                              "mailto:info@froschkoenig24.com",
                                            title: "E-Mail senden"
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            { staticClass: "svg_item-mail" },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "#svg_item-mail",
                                                  "xmlns:xlink":
                                                    "https://www.w3.org/1999/xlink"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        info@froschkoenig24.com"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "item-contact__item-link",
                                          attrs: {
                                            href: "tel:+498709263439",
                                            title: "anrufen"
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            { staticClass: "svg_item-phone" },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "#svg_item-phone",
                                                  "xmlns:xlink":
                                                    "https://www.w3.org/1999/xlink"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        Tel: 08709 26 34 39"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "item-contact__item item-contact__item--open"
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "p",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.singleContactMoDo"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleContactMoDoTime"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "p",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.singleContactFr"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleContactFrTime"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ])
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs d-block d-lg-none",
                            attrs: { role: "tablist" }
                          },
                          [
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link nav-link--inner",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive
                                  },
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemTechnicalData"
                                      )
                                    )
                                  ),
                                  _c("i", { staticClass: "fa fa-chevron-down" })
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isTechnicalDataTabActive
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                class: {
                                  active:
                                    !_vm.isDescriptionTabActive &&
                                    _vm.isTechnicalDataTabActive
                                },
                                attrs: {
                                  id:
                                    "data-" + _vm.currentVariation.variation.id,
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", { staticClass: "my-4" }, [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-striped table-hover table-sm"
                                    },
                                    [
                                      _c("tbody", [
                                        _vm.itemConfig.includes("item.id") ||
                                        _vm.itemConfig.includes("all")
                                          ? _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemId"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation.item.id
                                                  )
                                                )
                                              ])
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.currentVariation.variation.model !==
                                          "" &&
                                        (_vm.itemConfig.includes(
                                          "item.variation_model"
                                        ) ||
                                          _vm.itemConfig.includes("all"))
                                          ? _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemModel"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.model
                                                  )
                                                )
                                              ])
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.currentVariation.variation
                                          .weightG !== "" &&
                                        (_vm.itemConfig.includes(
                                          "item.weightG"
                                        ) ||
                                          _vm.itemConfig.includes("all"))
                                          ? _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemWeight"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.weightG
                                                  ) + " g"
                                                )
                                              ])
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.itemConfig.includes(
                                          "item.variation_dimensions"
                                        ) || _vm.itemConfig.includes("all")
                                          ? _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemDimensions"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.currentVariation
                                                        .variation.lengthMM
                                                    )
                                                  )
                                                ]),
                                                _vm._v("×"),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.currentVariation
                                                        .variation.widthMM
                                                    )
                                                  )
                                                ]),
                                                _vm._v("×"),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.currentVariation
                                                        .variation.heightMM
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  " mm\n                                            "
                                                )
                                              ])
                                            ])
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs d-block d-lg-none",
                            attrs: { role: "tablist" }
                          },
                          [
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link nav-link--inner",
                                  attrs: {
                                    href: "#service-versand",
                                    "data-toggle": "tab",
                                    role: "tab"
                                  },
                                  on: {
                                    "~mouseover": function($event) {
                                      return _vm.$store.dispatch(
                                        "loadComponent",
                                        "item-service-versand"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleTabsService"
                                      )
                                    )
                                  ),
                                  _c("i", { staticClass: "fa fa-chevron-down" })
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane",
                            attrs: { role: "tabpanel", id: "service-versand" }
                          },
                          [
                            _c(
                              "lazy-load",
                              { attrs: { component: "item-service-versand" } },
                              [_vm._t("versand")],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs d-block d-lg-none",
                            attrs: { role: "tablist" }
                          },
                          [
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link nav-link--inner",
                                  attrs: {
                                    href: "#zahlungsarten",
                                    "data-toggle": "tab",
                                    role: "tab"
                                  },
                                  on: {
                                    "~mouseover": function($event) {
                                      return _vm.$store.dispatch(
                                        "loadComponent",
                                        "item-zahlungsarten"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleTabsPayments"
                                      )
                                    )
                                  ),
                                  _c("i", { staticClass: "fa fa-chevron-down" })
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane",
                            attrs: { role: "tabpanel", id: "zahlungsarten" }
                          },
                          [
                            _c(
                              "lazy-load",
                              { attrs: { component: "item-zahlungsarten" } },
                              [_vm._t("payments")],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs d-block d-lg-none",
                            attrs: { role: "tablist" }
                          },
                          [
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "nav-link nav-link--inner js--reviews-tab",
                                  attrs: {
                                    href: "#bewertung",
                                    "data-toggle": "tab",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleTabsReviews"
                                      )
                                    )
                                  ),
                                  _c("i", { staticClass: "fa fa-chevron-down" })
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane",
                            attrs: { role: "tabpanel", id: "bewertung" }
                          },
                          [
                            _vm._t("FeedbackContainer"),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-none" }, [
                              _c("div", { staticClass: "stars js-stars" }, [
                                _c("input", {
                                  staticClass: "star star-1",
                                  attrs: {
                                    id: "star-1",
                                    type: "radio",
                                    value: "1",
                                    name: "ratingValue",
                                    "data-com.onepassword.iv": "1"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "star star-1",
                                    attrs: { for: "star-1" }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-grey",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-grey",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-orange d-none",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-orange",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "star star-2",
                                  attrs: {
                                    id: "star-2",
                                    type: "radio",
                                    value: "2",
                                    name: "ratingValue",
                                    "data-com.onepassword.iv": "2"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "star star-2",
                                    attrs: { for: "star-2" }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-grey",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-grey",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-orange d-none",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-orange",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "star star-3",
                                  attrs: {
                                    id: "star-3",
                                    type: "radio",
                                    value: "3",
                                    name: "ratingValue",
                                    "data-com.onepassword.iv": "3"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "star star-3",
                                    attrs: { for: "star-3" }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-grey",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-grey",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-orange d-none",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-orange",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "star star-4",
                                  attrs: {
                                    id: "star-4",
                                    type: "radio",
                                    value: "4",
                                    name: "ratingValue",
                                    "data-com.onepassword.iv": "4"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "star star-4",
                                    attrs: { for: "star-4" }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-grey",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-grey",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-orange d-none",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-orange",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "star star-5",
                                  attrs: {
                                    id: "star-5",
                                    type: "radio",
                                    value: "5",
                                    name: "ratingValue",
                                    "data-com.onepassword.iv": "5"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "star star-5",
                                    attrs: { for: "star-5" }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-grey",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-grey",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "star-orange d-none",
                                        attrs: { width: "14", height: "13" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg_star-orange",
                                            "xmlns:xlink":
                                              "https://www.w3.org/1999/xlink"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._t("trustpilot-widget")
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs d-block d-lg-none",
                            attrs: { role: "tablist" }
                          },
                          [
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link nav-link--inner",
                                  attrs: {
                                    href: "#contact",
                                    "data-toggle": "tab",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleTabsContact"
                                      )
                                    )
                                  ),
                                  _c("i", { staticClass: "fa fa-chevron-down" })
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane",
                            attrs: { role: "tabpanel", id: "contact" }
                          },
                          [
                            _c("div", { staticClass: "cmp-contact" }, [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12 col-lg-9" }, [
                                  _c("p", { staticClass: "contact-headline" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.contact"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "m-b-3" }, [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.contactShopMessage"
                                          )
                                        ) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 p-x-0 well well-sm"
                                      },
                                      [_vm._t("contactform")],
                                      2
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs-content")
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._t("crosssellinglowerlist"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "scroll-to-basket",
                    on: {
                      click: function($event) {
                        return _vm.scrollToBasket()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-arrow-up",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-shopping-cart",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ],
              2
            )
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "share-dd" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.facebook.com/froschkoenig24.de",
            target: "_blank"
          }
        },
        [
          _c("i", { staticClass: "fab fa-facebook-square" }),
          _vm._v(" Facebook")
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.instagram.com/froschkoenig_24_living/",
            target: "_blank"
          }
        },
        [_c("i", { staticClass: "fab fa-instagram" }), _vm._v(" Instagram")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.youtube.com/channel/UC5GhTdbrQF_dMqcv2JNEapQ",
            target: "_blank"
          }
        },
        [_c("i", { staticClass: "fab fa-youtube" }), _vm._v(" Youtube")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "share-dd" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.facebook.com/froschkoenig24.de",
            target: "_blank"
          }
        },
        [_c("i", { staticClass: "fa fa-facebook-square" }), _vm._v(" Facebook")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.instagram.com/froschkoenig_24_living/",
            target: "_blank"
          }
        },
        [_c("i", { staticClass: "fa fa-instagram" }), _vm._v(" Instagram")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.youtube.com/channel/UC5GhTdbrQF_dMqcv2JNEapQ",
            target: "_blank"
          }
        },
        [_c("i", { staticClass: "fa fa-youtube" }), _vm._v(" Youtube")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }